import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SidebarComponent} from './sidebar/sidebar.component';
import {FooterComponent} from './footer/footer.component';
import {HeaderComponent} from './header/header.component';
import {LocalizationModule} from '@abp/ng.core';
import {
  LanguageSelectionComponent
} from '@shared/modules/layout-components/header/language-selection/language-selection.component';
import {SharedModule} from '@shared/shared.module';
import {RouterModule} from '@angular/router';
import {NotificationBellComponent} from './header/notification-bell/notification-bell.component';

@NgModule({
  exports: [SidebarComponent, HeaderComponent, LanguageSelectionComponent],
  imports: [
    CommonModule,
    LocalizationModule,
    SharedModule.forChild(),
    RouterModule,
    SidebarComponent,
    FooterComponent,
    HeaderComponent,
    LanguageSelectionComponent,
    NotificationBellComponent
  ]
})
export class LayoutComponentsModule {
}
